import { render } from "./AddZam.vue?vue&type=template&id=5d1b5db8&scoped=true"
import script from "./AddZam.vue?vue&type=script&lang=js"
export * from "./AddZam.vue?vue&type=script&lang=js"

import "./AddZam.vue?vue&type=style&index=0&id=5d1b5db8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1b5db8"]])

export default __exports__